import { useQuery } from "@tanstack/react-query";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import ky from "ky";

const queryKeyBase = "ddc-api-user";

const url = `/landing/`;
const baseUrl = `${url}nxlambda/user/`;

const staleTime = 600000; // 10 mins
export function useGetUser(authInvalid?: boolean) {
  return useQuery({
    queryKey: [queryKeyBase],
    queryFn: () => fetchUserGet(),
    staleTime,
    retry: false,
    enabled: !authInvalid
  });
}

const fetchUserGet = () => {
  return ky.get(baseUrl).json<decodedJwtAndPermissions>();
};
